import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Training from "./pages/Training";
import Gallery from "./pages/Gallery";
import BottomHeader from "./pages/BottomHeader"
import "./styles/App.css";

function App() {
  return (
    <>
      <Header />
      <BottomHeader/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/training" element={<Training />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/home" element={<home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
